module.exports = __webpack_public_path__ + "img/4.750d9144.jpg";